<div class="table-responsive animated fadeIn slow">

    <h2 class="text-center titulo">MÓDULO DE REPORTES DIOT</h2>

    <div class="contenedor-reportes-full">
        <div class="panel-reportes">
            <div class="row g-4">

                <div class="col-md-3">
                    <label class="label-reportes">
                        <i class="fa fa-calendar-alt me-1"></i>
                        Fecha inicio
                    </label>
                    <input type="date" class="input-reportes" [(ngModel)]="fechaInicio">
                </div>

                <div class="col-md-3">
                    <label class="label-reportes">
                        <i class="fa fa-calendar-check me-1"></i>
                        Fecha fin
                    </label>
                    <input type="date" class="input-reportes" [(ngModel)]="fechaFin">
                </div>

                <div class="col-md-3 d-flex align-items-end">
                    <button class="btn-reportes btn-vino w-100" (click)="consultarFacturasProveedor()">
                        <i class="fa fa-file-invoice-dollar me-2"></i>
                        Polízas registradas
                    </button>
                </div>

            </div>
        </div>
    </div>

    <hr class="separador-reportes">

    <div *ngIf="reporte.length > 0" class="contenedor-tabla-reportes">

        <div class="titulo-resultados">
            <i class="fa fa-table me-2"></i> Resultados del Reporte
        </div>

        <div class="table-responsive">
            <table class="tabla-asignaturas">
                <thead>
                    <tr>
                        <th *ngFor="let col of columnas">{{ col }}</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let r of reporte">
                        <td *ngFor="let col of columnas">

                            <!-- 🔥 CAMBIO: mostrar subtotal redondeado -->
                            <ng-container *ngIf="col === 'subtotal'; else normal">
                                {{ (r[col] ? (r[col] | number:'1.0-0') : '') }}
                            </ng-container>

                            <ng-template #normal>
                                {{ r[col] }}
                            </ng-template>

                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr class="fila-total">
                        <td *ngFor="let col of columnas">

                            <strong *ngIf="col === columnas[0]">TOTAL</strong>

                            <strong *ngIf="col === 'subtotal'">
                                {{ totalGeneral | number:'1.0-0' }}
                            </strong>

                        </td>
                    </tr>
                </tfoot>

            </table>
        </div>

        <div class="acciones-reportes d-flex gap-3">
            <button class="btn-exportar btn-dark" (click)="exportarTXT()">
                <i class="fa fa-file-alt me-2"></i>
                Exportar TXT
            </button>
        </div>

    </div>
</div>